import { AfterViewInit, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { DomainConfigComponent } from "@app/domain-config.component";
import { Cara } from '@app/services/suite-shell.logic';
import { SuiteShellService } from '@app/services/suite-shell.service';

@Component({
    selector: "app-admin-tabs",
    templateUrl: "./admin-tabs.component.html",
    styleUrls: ["./admin-tabs.component.scss"],
    standalone: false
})
export class AdminTabsComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() selecto: number;
  @ViewChild('report') reportTpl: TemplateRef<unknown>;
  cara: Cara = 'classic';
  whatsappEnabled = false;
  private enReporte = false;
  private sub: Subscription;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private shell: SuiteShellService,
    private domainConfig: DomainConfigComponent
  ) {}

  ngOnInit() {
    this.enReporte = this.router.url.split('?')[0].endsWith('/admin/report');
    this.sub = this.shell.cara$.subscribe((cara) => this.cara = cara);
    // El tab WhatsApp solo se muestra si el canal está habilitado para el tenant
    // (trackvision.whatsappEnabled, que controla Inprovider). La config del dominio ya está
    // cargada tras el login; por seguridad forzamos load() y leemos el flag.
    Promise.resolve(this.domainConfig.load && this.domainConfig.load())
      .catch(() => {})
      .finally(() => {
        try { this.whatsappEnabled = this.domainConfig.isWhatsappEnabled(); } catch { this.whatsappEnabled = false; }
      });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.enReporte && this.reportTpl) {
      setTimeout(() => this.modalOpenUserManage(this.reportTpl));
    }
  }

  activo(n: number): boolean {
    if (this.enReporte) return n === 6;
    return this.selecto === n;
  }

  modalOpenUserManage(content) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
}
